import React from 'react';
import { NavLink } from 'react-router-dom';

export interface PrimaryProps {
  children: React.ReactNode;
  to: string;
  className?: string;
}

export const Primary: React.FC<PrimaryProps> = (props) => {

  const { children, to, className } = props;

  return (
    <NavLink to={to} className={className ?? 'border-b-app-s border-b-transparent hover:border-b-app-white'}>
      {children}
    </NavLink>
  );
};
